module.exports = __webpack_public_path__ + "media/init/static/favicon-7477625b9521b651d3384220691df106.png";